import React from 'react';
import { MapPin, ShieldCheck, Lightbulb, BadgeDollarSign } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: MapPin,
    label: '100% Locally Owned'
  }, {
    icon: Lightbulb,
    label: 'Design-Driven Approach'
  }, {
    icon: BadgeDollarSign,
    label: 'Free Estimates'
  }, {
    icon: ShieldCheck,
    label: 'Serving All of Arizona'
  }];
  return <section className="w-full bg-[#1A1A1A] py-6 border-b border-white/5" data-id="element-215">
      <div className="container mx-auto px-4" data-id="element-216">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-center justify-center text-center" data-id="element-217">
          {trustItems.map((item, index) => <div key={index} className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-218">
              <item.icon className="w-6 h-6 text-[var(--brand-gold)] flex-shrink-0" data-id="element-219" />
              <span className="text-white text-sm md:text-base font-medium whitespace-nowrap" data-id="element-220">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}